module.exports = __webpack_public_path__ + "media/images/visa-535e9b46eaeb69e639b11cc005f03ec6.png";